import { type AgRadialColumnSeriesOptions, PolarChartModule, VERSION } from 'ag-charts-community';
import { ChartAxisDirection, POLAR_AXIS_TYPE, type SeriesModuleDefinition } from 'ag-charts-core';

import { RadialColumnSeries } from './radialColumnSeries';
import { radialColumnSeriesOptionsDef } from './radialColumnSeriesOptionsDef';
import { RADIAL_COLUMN_SERIES_THEME } from './radialColumnThemes';

export const RadialColumnSeriesModule: SeriesModuleDefinition<AgRadialColumnSeriesOptions> = {
    type: 'series',
    name: 'radial-column',
    chartType: 'polar',
    enterprise: true,
    stackable: true,
    groupable: true,
    version: VERSION,
    dependencies: [PolarChartModule],

    options: radialColumnSeriesOptionsDef,
    defaultAxes: { angle: { type: POLAR_AXIS_TYPE.ANGLE_CATEGORY }, radius: { type: POLAR_AXIS_TYPE.RADIUS_NUMBER } },
    axisKeys: { [ChartAxisDirection.Angle]: 'angleKeyAxis', [ChartAxisDirection.Radius]: 'radiusKeyAxis' },
    themeTemplate: RADIAL_COLUMN_SERIES_THEME,

    create: (ctx) => new RadialColumnSeries(ctx),
};
